"use client";

import React from "react";
import { Box } from "@mui/material";
import FeefoReviewsSummary from "@/components/common/feefo-reviews-section/feefo-reviews-summary";
import { FeefoSummary } from "@/types/dto/common/feefo-reviews";

export interface FeefoSummarySectionProps {
  summary: FeefoSummary;
  isSmFeefoSummary?: boolean;
  moduleRankingPosition?: string;
}

/**
 * Feefo summary section for landing pages.
 * Renders the Feefo reviews summary in a full-width blue background section.
 * When nested inside another component (isSmFeefoSummary provided), ranking is suppressed.
 */
const FeefoSummarySection: React.FC<FeefoSummarySectionProps> = ({
  summary,
  isSmFeefoSummary,
  moduleRankingPosition = "2"
}) => (
    <Box
      component={isSmFeefoSummary ? "div" : "section"}
      sx={{
        width: "100%",
        backgroundColor: isSmFeefoSummary ? "transparent" : "background.cool_strong",
        display: "flex",
        justifyContent: isSmFeefoSummary ? { xs: "center", sm: "flex-start" } : "center",
        alignItems: "center",
        padding: isSmFeefoSummary ? "4rem 0 0" : { xs: "4rem 2.4rem", md: "4rem 2.4rem", lg: "2.4rem" }
      }}
      aria-label="feefo summary section"
      {...(!isSmFeefoSummary && {
        "data-track": "visibility",
        "data-parent-container-type": "feefo summary section",
        "data-module-name": "Feefo Summary Section",
        "data-ranking-algorithm": "manual",
        "data-module-ranking-position": moduleRankingPosition
      })}

    >
      <FeefoReviewsSummary isSmFeefoSummary={isSmFeefoSummary} summary={summary} />
    </Box>
  );

export default FeefoSummarySection;
